import { Component } from '@angular/core';

@Component({
	selector: 'ui-new-separator',
	styleUrls: ['separator.component.scss'],
	template: ``,
	standalone: true,
})
export class UiNewSeparatorComponent {}
